import React from 'react'
import SectionCollapse from '../../../../../section/SectionCollapse'
import CardsInformation from './CardsInformation'
import GranularSteps from './GranularSteps'
import TextValue from '../../../../../text/TextValue'
import GrowthGoals from './GrowthGoals'
import WorkedExamples from './WorkedExamples'

const DRInfo = ({ detail = {} }) => {
  return (
    <>
      <TextValue title='Curriculum' value={detail.curriculum} />
      <div className='py-2'/>
      <SectionCollapse title='Basic Information'>
        <CardsInformation detail={detail} />
      </SectionCollapse>
      <GranularSteps lcs={detail.lcs || []} />
      <WorkedExamples workedExamples={detail.workedExamples || []} />
      <GrowthGoals growthGoals={detail.growthGoals || []} />
    </>
  )
}

export default DRInfo